import React from 'react';
import './HomePage.css';

const PartnersCarousel = () => {
  return (
    <div className='partners-carousel'>
      <div class="partners-logo-slider">
        <p class="sliderTitle">Trusted by 200,000+ leading organizations</p>
        <div class="slide-track">
            <div class="slide">
                <img src="images/siemens-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/lt-switchgear-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/schneider-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/rockwell-automation-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/siemens-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/lt-switchgear-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/schneider-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/rockwell-automation-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/siemens-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/lt-switchgear-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/schneider-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/rockwell-automation-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/siemens-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/lt-switchgear-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/schneider-logo.png" height="200" width="250" alt="" />
            </div>
            <div class="slide">
                <img src="images/rockwell-automation-logo.png" height="200" width="250" alt="" />
            </div>

        </div>
    </div>
    </div>
  )
}

export default PartnersCarousel
